import { MainWrapper } from "react-design-system";
import type { frontRoutes } from "shared";
import { ConventionFormWrapper } from "src/app/components/forms/convention/ConventionFormWrapper";
import { HeaderFooterLayout } from "src/app/components/layout/HeaderFooterLayout";
import { frontErrors } from "src/app/pages/error/front-errors";
import type { Route } from "type-route";
import { ErrorPage } from "../error/ErrorPage";

export type ConventionImmersionForExternalsRoute = Route<
  typeof frontRoutes.conventionImmersionForExternals
>;

type ConventionPageForExternalsProperties = {
  route: ConventionImmersionForExternalsRoute;
};

export const ConventionPageForExternals = ({
  route,
}: ConventionPageForExternalsProperties): JSX.Element => {
  const externalConsumer =
    externalConsumers[route.params.consumer as ConventionFormSource];

  if (!externalConsumer) {
    return (
      <ErrorPage
        error={frontErrors.convention.externalConsumerNotFound({
          consumerName: route.params.consumer,
        })}
      />
    );
  }

  return externalConsumer.isIframe ? (
    <ConventionFormWrapper
      internshipKind="immersion"
      mode="create-convention-from-scratch"
    />
  ) : (
    <HeaderFooterLayout>
      <MainWrapper layout="default">
        <ConventionFormWrapper
          internshipKind="immersion"
          mode="create-convention-from-scratch"
        />
      </MainWrapper>
    </HeaderFooterLayout>
  );
};

export type ConventionFormSource = keyof typeof externalConsumers;
const externalConsumers = {
  diagoriente: { isIframe: true },
  "milo-paris": { isIframe: false },
} satisfies Record<string, { isIframe: boolean }>;
